/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CONTENT INDICATOR
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	contentindicator: {
		whiteSpace: 'nowrap',
		'&.type-sort': {
			'& .contenttype': {
				cursor: 'pointer'
			}
		},
        '&.greyOut-true':{
            pointerEvents: 'none',
            filter: 'grayScale(1)',
            opacity: .4
        }
	}
});